export const SET_SERVICE_DETAIL: string = "SET_SERVICE_DETAIL";
export const GET_SERVICE_REQUEST: string = "GET_SERVICE_REQUEST";
